import {
  DEFAULT_ASSETS_LIST_VISIBILITY,
  MAX_ASSETS_LIST_NAME_LENGTH,
} from "@kagami/shared/assetsList";

export { DEFAULT_ASSETS_LIST_VISIBILITY, MAX_ASSETS_LIST_NAME_LENGTH };

export const ASSETS_LIST_DRAFT_STORAGE_PREFIX = "assetsList.draft";

export const ASSETS_LIST_EXPANDED_STORAGE_KEY = "assetsList.expanded";

export const DEFAULT_ASSETS_LIST_EXPANDED = false;

export const UNSAVED_ASSETS_LIST_LABEL = "Unsaved list";

// Seeds a fresh working list's name field so it reads as an actual,
// renameable name rather than the UNSAVED_ASSETS_LIST_LABEL placeholder.
export const DEFAULT_ASSETS_LIST_NAME = "New List";

export const AssetsListSaveOutcome = {
  Saved: "saved",
  RequiresSaveAs: "requiresSaveAs",
} as const;

export type AssetsListSaveOutcome =
  (typeof AssetsListSaveOutcome)[keyof typeof AssetsListSaveOutcome];

export const ASSETS_LIST_BOX_SIZE_CLASS =
  "h-full aspect-video max-h-40 min-h-12";

// Must clear AssetsList__row's `min-h-20` floor plus the toolbar's chrome
// (~49px), or the row overflows the strip.
export const ASSETS_LIST_PANEL_HEIGHT = 132;
